// @flow
import {
  PARAMETER_SEPARATOR,
  DEFAULT_UI_PARAMETERS,
} from "../../constants/Constants";
import { getSetting } from "../../constants/Settings";

/**
 * Querystring parameter
 */
class Parameter {
  _prefix: ?string;
  _name: string;
  _value: ?string;
  _isModUIParameter: boolean | null = null;

  /**
   */
  constructor(prefix: ?string, name: string, value: ?string) {
    this._prefix = prefix;
    this._name = name;
    this._value = value;
  }

  /**
   * Getting prefix
   */
  get prefix(): ?string {
    return this._prefix;
  }

  /**
   * Getting name
   */
  get name(): string {
    return this._name;
  }

  /**
   * Getting value
   */
  get value(): ?string {
    return this._value;
  }

  /**
   * Create parameter from string input
   */
  static fromString(parameter: string): null | Parameter {
    if (parameter == null || parameter === "" || !parameter.includes("=")) {
      return null;
    }

    // parameter has the structure prefix~name=value
    const namePart = parameter.substring(0, parameter.indexOf("="));
    const value = parameter.substring(parameter.indexOf("=") + 1);

    let prefix;
    let name = decodeURIComponent(namePart);
    if (name.includes(PARAMETER_SEPARATOR)) {
      prefix = name.substring(0, name.indexOf("~"));
      name = name.substring(name.indexOf("~") + 1);
    }

    if (name === "") {
      return null;
    }

    return new Parameter(prefix, name, decodeURIComponent(value));
  }

  /**
   * Convert parameter to string
   */
  toString(withPrefix: boolean = true): string {
    if (!this.name) {
      return "";
    }

    const value = this.value == null ? "" : this.value;

    return withPrefix && this.prefix
      ? `${this.prefix}${PARAMETER_SEPARATOR}${this.name}=${value}`
      : `${this.name}=${value}`;
  }

  /**
   */
  toQuerystring(withPrefix: boolean = true): string {
    if (!this.name) {
      return "";
    }

    const value = this.value == null ? "" : encodeURIComponent(this.value);

    return withPrefix && this.prefix
      ? `${this.prefix}${PARAMETER_SEPARATOR}${this.name}=${value}`
      : `${this.name}=${value}`;
  }

  /**
   * Indicates if parameter can be send to the Be Informed modular UI
   */
  get isModUIParameter(): boolean {
    if (this._isModUIParameter == null) {
      const uiParameterSetting = getSetting("UI_PARAMETERS", []);
      this._isModUIParameter = ![
        ...DEFAULT_UI_PARAMETERS,
        ...uiParameterSetting,
      ].includes(this.name);
    }

    return this._isModUIParameter;
  }
}

export default Parameter;
